module.exports = __webpack_public_path__ + "static/media/pic9.bce0cd6a.jpg";